import { render, staticRenderFns } from "./RemoveTeamModal.vue?vue&type=template&id=0db7f258&lang=pug"
import script from "./RemoveTeamModal.vue?vue&type=script&lang=js"
export * from "./RemoveTeamModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports